import React from "react";
import "../../styles/spinner.css"

export default function Spinner(){

    return(
        <div className="text-center">
            <div className="lds-hourglass text-center"></div>
        </div>
    )

}